import { Typography } from '@mui/material';
import { colors } from '../styles/globalStyles';
import textData from '../data/data.json';
import { useRecoilValue } from 'recoil';
import { selectedLanguageAtom } from '../recoil/atoms/languageAtom';

export const StatusBlock = ({ status }) => {
    const selectedLanguage = useRecoilValue(selectedLanguageAtom);
    const { behaviorManagementStatus } = textData[selectedLanguage];
    if (!status) {
        return null;
    }
    return (
        <Typography
            sx={{
                color: status === 'SUCCESS' ? colors.green : colors.red,
            }}
        >
            {status === 'SUCCESS' ? behaviorManagementStatus.status.success : null}
            {status === 'ERROR_VAL' ? behaviorManagementStatus.status.errorVal : null}
            {status === 'ERROR_NET' ? behaviorManagementStatus.status.errorNet : null}
        </Typography>
    );
};
